<template>
  <div>
    <b-container fluid class="">
      <b-row>
        <b-col class="">
          <h4 class="text-center p-3">Send Emails <span class="smh"></span></h4>
        </b-col>
      </b-row>
      <b-row>
        <b-col class="">
          <b-overlay
            :show="uploadingpic"
            opacity="0.5"
            blur="1px"
            spinner-type="grow"
          >
            <form @submit.prevent="sendEmail" enctype="multipart/form-data">
              <b-form-group label="Target" class="label" label-for="target">
                <b-form-select
                  id="target"
                  v-model="email.target"
                  :options="targets"
                  required
                >
                </b-form-select>
              </b-form-group>

              <b-form-group
                label="Email Campaign Title"
                label-for="title"
                class="label"
              >
                <b-form-input
                  type="text"
                  id="title"
                  v-model="email.title"
                ></b-form-input>
              </b-form-group>

              <b-form-group
                label="Email Campaign Subject"
                label-for="subject"
                class="label"
              >
                <b-form-input
                  type="text"
                  id="subject"
                  v-model="email.subject"
                ></b-form-input>
              </b-form-group>

              <b-form-group
                label="Email Campaign Description"
                label-for="description"
                class="label"
              >
                <b-form-textarea
                  type="text"
                  id="description"
                  rows="5"
                  v-model="email.description"
                ></b-form-textarea>
              </b-form-group>

              <b-form-group label="Email Campaign Body" label-for="optiond">
                <vue2-tinymce-editor v-model="email.body"></vue2-tinymce-editor>
              </b-form-group>

              <b-form-group>
                <div class="text-center">
                  <b-overlay
                    :show="sending"
                    rounded
                    opacity="0.6"
                    spinner-small
                    spinner-variant="primary"
                    class=""
                  >
                    <b-button
                      :disabled="sending"
                      type="submit"
                      class="p-3 text-bold"
                      variant="primary"
                    >
                      Start Campaign
                    </b-button>
                  </b-overlay>
                  <b-button
                    v-if="sending"
                    class="w-100 p-2 mt-3 btntxt"
                    variant="dark"
                    @click="stopproceed"
                  >
                    Cancel
                  </b-button>
                </div>
              </b-form-group>
            </form>
          </b-overlay>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
// import { VueEditor } from "vue2-editor";
import { mapActions, mapState } from "vuex";
import axios from "axios";
import { Vue2TinymceEditor } from "vue2-tinymce-editor";

export default {
  components: {
    Vue2TinymceEditor
  },

  data() {
    return {
      email: this.getForm(),
      sending: false,
      targets: [
        { text: "--Select Email Target--", value: null },
        { text: "Email not Confirmed", value: "email-unconfirmed" },
        {
          text: "Free Users Without Trials",
          value: "free-users-without-trials"
        },
        { text: "All Users", value: "all-users" },
        { text: "Premium Users", value: "premium-users" },
        { text: "Newsletter", value: "news-letter" },
        { text: "Comeback Reminders", value: "comeback-reminders" },
        { text: "Weekly report", value: "weekly-report" },
        { text: "Monthly report", value: "monthly-report" }
      ],
      imageurl: "",
      uploadingpic: false
    };
  },
  methods: {
    ...mapActions("admin", ["emailUsers", "uploadImage"]),
    getForm() {
      return {
        target: null,
        title: "",
        body: ""
      };
    },
    handleImage(file, Editor, cursorLocation, resetUploader) {
      this.uploadingpic = true;
      let fData = this.gatFormD(file);

      axios
        .post(
          //"https://quicktest.futavilla.com/apis/filehandler.php",
          "http://localhost/quicktest/src/apis/filehandler.php",
          fData,
          {
            header: {
              "Content-Type": "multipart/form-data"
            }
          }
        )
        .then(response => {
          //console.log(response.data);
          Editor.insertEmbed(cursorLocation, "image", response.data.url);
          resetUploader();
          this.uploadingpic = false;
          this.$bvModal
            .msgBoxOk(
              "Image Uploaded Successfully. Proceed with Email Content.",
              {
                title: "Image Uploaded",
                size: "xs",
                centered: true
              }
            )
            .then(() => {});
        })
        .catch(() => {
          this.$bvModal
            .msgBoxOk(
              "Check your Network Connection. Could not upload Image.",
              {
                title: "No Network Connection",
                size: "xs",
                centered: true
              }
            )
            .then(() => {
              this.uploadingqimage = false;
            });
          //console.log(error);
        });
    },
    gatFormD(file) {
      let data = new FormData();

      data.append("image", file);
      //data = {
      //eimage: file,
      //};
      return data;
    },
    sendEmail() {
      this.sending = true;
      return this.emailUsers(this.email).then(() => {
        this.sending = false;

        this.$bvModal
          .msgBoxOk("Emails Sent Successfully.", {
            title: "Email Sent",
            size: "xs",
            centered: true
          })
          .then(() => {});
      });
    },
    stopproceed() {
      this.sending = false;
    }
  },
  computed: {
    ...mapState({
      url: state => state.admin.imageurl
    })
  }
};
</script>

<style scoped></style>
